import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import icGroup from '@iconify/icons-ic/twotone-group';
import { ApexOptions } from 'src/@vex/components/chart/chart.component';
import { createDateArray } from 'src/@vex/utils/create-date-array';
import { defaultChartOptions } from 'src/@vex/utils/default-chart-options';
import { ProductosResumen } from 'src/app/models/generic/ProductosResumen';
import { Constantes } from 'src/app/models/modules/Constantes';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { ProductosService } from 'src/app/services/productos.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { TamanoAppService } from '../../services/tamanoapp.service';

@Component({
  selector: 'globalresumenafiliados',
  templateUrl: './globalresumenafiliados.component.html',
  styleUrls: ['./globalresumenafiliados.component.scss']
})
export class GlobalresumenafiliadosComponent implements OnInit{
  
  series: ApexNonAxisChartSeries | ApexAxisChartSeries;
  options: ApexOptions;

  userSessionsSeries: ApexAxisChartSeries;
  mostrarCargando: boolean = true;
  textoGrafica: string = 'Afiliados';

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public tamanoAppService: TamanoAppService) {}

    ngOnInit() {
      if (this.autenticacionService.EstaAutenticado()) {
        this.cargarResumen();

        this.productosService.NotificarCambiarResumen.subscribe((cambiarResumen: boolean) => {
          if (cambiarResumen) {
            this.cargarResumen();
          }
        });
      }
    }

    cargarResumen() {
      this.mostrarCargando = true;
      if (this.configuracionInicialService.ConfigLocal.TomarArchivosLocales) {
        this.configuracionInicialService.ObtenerConfiguracion(Constantes.CONFIGURACIONLOCAL_RESUMEN())
          .subscribe((resp: ProductosResumen[]) => {
            this.continuarCargarResumen(resp);
          },
          (error: Error) => {
            this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
            this.mostrarCargando = false;
            this.cd.detectChanges();
          },
          () => this.cd.detectChanges());
      } else {
        let formConsulta = this.fb.group({
          idAplicacion: 0,
          canal: ''
        });
        formConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionadoInicial);
        formConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionadoInicial);
        this.productosService.CargarProductosResumen(formConsulta.value).subscribe((resp: ProductosResumen[]) => {
          this.continuarCargarResumen(resp);
        },
        (error: Error) => {
          this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
          this.mostrarCargando = false;
          this.cd.detectChanges();
        },
        () => this.cd.detectChanges());
      }
  }

  continuarCargarResumen(resp: ProductosResumen[]) {
    this.productosService.ListaProductosResumen = resp;
    this.mostrarCargando = false;

    if (this.utilitariosService.VerificarContieneDatosLista(this.productosService.ListaProductosResumen)) {
      this.textoGrafica = this.productosService.ListaProductosResumen[0].descripcion;

      let valoresGrafica: number[] = [];
      let labelsGrafica: string[] = [];

      for (let index = 0; index < this.productosService.ListaProductosResumen.length; index++) {
        valoresGrafica.push(this.productosService.ListaProductosResumen[index].cantidad);
        labelsGrafica.push(this.productosService.ListaProductosResumen[index].fecha);
      }

      this.userSessionsSeries = [
        {
          name: this.productosService.ListaProductosResumen[0].descripcion,
          data: valoresGrafica
        },
      ];
      

      this.options = defaultChartOptions({
        grid: {
          show: true,
          strokeDashArray: 3,
          padding: {
            left: 2
          }
        },
        chart: {
          type: 'area',
          sparkline: {
            enabled: false
          },
          zoom: {
            enabled: false
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 0.9,
            opacityFrom: 0.7,
            opacityTo: 0.5,
            stops: [0, 90, 100]
          }
        },
        colors: ['var(--theme-color-principal)', '#008ffb'],
        labels: labelsGrafica,
        xaxis: {
          type: 'category',
          title: {text: this.productosService.ListaProductosResumen[0].descripcionAdicional},
          labels: {
            show: true
          },
        },
        yaxis: {
          labels: {
            show: true
          }
        },
        legend: {
          show: false
        }
      });

      if (this.tamanoAppService.mostrarModoEscritorio) {
        this.options.chart.height = '180px';
      }

      this.series = this.userSessionsSeries;
    }
  }

  
}
